/**
 * Created by OBL on 14/01/2016.
 */
define('adminKitpController',[
    'module',
    'underscore',
    'app',
    'adminKitpView',
    'bootbox',
    'kitpCreateEditLayoutView',
    'settings',
    'entities/kitp'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var SuperAdminKitpListController = {
        showKitpList: function(data) {
            this.data = data;
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'kitp:delete', _.bind(this.onDelete, this));
            view.listenTo(view, 'kitp:edit', _.bind(this.onEdit, this));
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('kitpListTab').show(view);
        },

        showKitpAdd: function(mbKitSecId) {
            this.showKitpAddEdit(App.request('kitp:model', {
                refAssay: {
                    secId: mbKitSecId
                }
            }), true);
        },

        showKitpAddEdit: function(model, newItem) {
            this.createEditView = new CreateEditLayoutView({
                kitpModel: model,
                newItem: newItem
            });
            this.createEditView.show({
                title: _.i18n('kitp.new')
            });
        },

        showKitpEdit: function(assaySecId, kitpSecId) {
            var that = this;
            var model = App.request('kitp:model', {
                refKit: {
                    secId: assaySecId
                },
                secId: kitpSecId
            });
            model.fetch().done(function() {
                that.showKitpAddEdit(model, false);
            });
        },

        onEdit: function(mbKitSecId, kitpSecId){
            App.navigate('admin/assays/' + mbKitSecId + '/kitp/' + kitpSecId + '/edit', {trigger: true});
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('kitp:get-collection-url', this.data.model.get('secId')),
                rowCountUrl: App.request('kitp:get-count-url', this.data.model.get('secId'))
            };

            this.view.displayGrid(data);
        },

        onDelete: function(kitSecId, secId){
            bootbox.confirm(_.i18n('kitp.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('kitp:delete', kitSecId, secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = SuperAdminKitpListController;
});
